import {Platform, StyleSheet, TextStyle} from 'react-native';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {H6Text} from '@buncha/components/core/text';
import React from 'react';

interface Props {
  name: string;
  size?: number;
  nameStyle?: TextStyle;
}

const ItemName = (props: Props) => {
  const theme = useColorThemeType();
  const muliFont = useFontTheme();

  return (
    <H6Text
      style={[
        styles.textHeader,
        {
          fontFamily: muliFont[700].normal,
          color: theme?.text.blue[300],
          fontSize: props?.size,
          ...props?.nameStyle,
        },
      ]}>
      {props?.name}
    </H6Text>
  );
};

export default React.memo(ItemName);

const styles = StyleSheet.create({
  pillContainer: {
    marginBottom: -3,
  },
  highlightText: {
    borderRadius: 20,
    paddingHorizontal: 10,
    gap: 5,
    marginVertical: 5,
    marginBottom: Platform.OS === 'android' ? -5 : 0,
  },
  textHeader: {
    textAlign: 'left',
  },
});
